module.exports = __webpack_public_path__ + "media/green screen.2f075e24.mp4";